export default "__VITE_ASSET__Dit6MRuk__"